import React from "react";
import classNames from "classnames";
import styles from "./styles.module.scss";
import Image from "@/app/components/image";
import { Assets } from "@/app/utils/assets";

interface EmptyImageProps {
  className?: string;
}

const EmptyImage: React.FC<EmptyImageProps> = ({ className }) => {
  return (
    <div className={classNames(styles.emptyImage, className)}>
      <Image className={styles.image} asset={Assets.noImage} />
    </div>
  );
};

export default EmptyImage;